export const defaultValues = {
  personId: null,
  name: null,
  lastname: null,
  dateBirth: null,
  documentType: null,
  documentNumber: null,
  expeditionDate: null,
  gender: null,
  phone: null,
  cellPhoneNumber: null,
  email: null,
  stateId: null,
  professionId: null,
  cityId: null,
  shirtSize: null,
  pantSize: null,
  shoeSize: null,
  documentIssueDate: null,
  maritalStatus: null,
  numberChildren: null,
  levelEducation: null,
  complementaryStudies: null,
  yearExpericence: null,
  ownVehicle: null,
  currentlyWorking: null,
  creationDate: new Date(),
  dateUpdate: null,
  userCreation: "Developer",
  userUpdate: null,
};

export const defaultValuesChilds = {
  personId: null,
  name: null,
  birthDate: null,
  creationDate: new Date(),
  dateUpdate: null,
  userCreation: "Developer",
  userUpdate: null,
};

export const childValues = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
];

export const experienceYears = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
  22, 23, 24, 25, 26, 27, 28, 29, 30,
];

export const alphNumbers = [
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
];
